jQuery(document).ready(function($) {
    if($('body').is('.page-template-quienes-somos')) {
        const modal = document.querySelector("#modal");
        const showButton = document.querySelectorAll(".encuentranos-btn");
        const closeButton = document.querySelector("dialog button");

        function closeModal() {
            document.body.style.overflow = "auto";
            modal.close();
        }

        function clickOutsideToClose(e) {
            if (e.target.id === 'modal') closeModal();
        }

        showButton.forEach((button) => button.addEventListener("click", () => {
                document.body.style.overflow = "hidden";
                modal.showModal();
            })
        );

        closeButton.addEventListener("click", () => {
            closeModal();
        });

        modal.addEventListener('click', clickOutsideToClose);


        let urlObject = new URL(window.location.href);
        let url = urlObject.protocol + "//" + urlObject.hostname;

        let companiesList = document.querySelectorAll(".companies-list li")

        fetch(url + "/wp-content/themes/itt/data/delegaciones-itt.json")
        .then((response) => response.json())
        .then((addresses) => {
            companiesList.forEach((item) => {
                let company = item.dataset.company;
                let companyAddresses = addresses.filter((address) => address.empresa == company);

                if (companyAddresses.length > 0) {
                    let addressesUl = document.createElement('ul');

                    companyAddresses.forEach((address)=> {
                        if(address.popUp=="true") {
                            let h4City = document.createElement('h4');
                            let h4CityContent = document.createTextNode(address.ciudad);
                            h4City.appendChild(h4CityContent);

                            let addressAddress = document.createElement('address');
                            let addressAddressContent = document.createTextNode(`${address.direccion}\n${address.pais}`);
                            addressAddress.appendChild(addressAddressContent);
                            addressAddress.style = "white-space: pre-wrap;"

                            let aPhone = document.createElement('span');
                            // chequeamos si el campo phone contiene algo más que un número de teléfono
                            let notPhoneChars = /[^\d\s\+]/;
                            if (notPhoneChars.test(address.phone)) {
                                // aquí pasan cosas
                                let HTMLPhoneString = address.phone;
                                let capturePhoneNumbers = /[^\d\s\+]?[\d\+][\d\s]+\d/g;
                                let phoneNumbers = [...address.phone.matchAll(capturePhoneNumbers)];
                                phoneNumbers.forEach((phoneNumber) => {
                                    let phoneNumberNoSpaces = phoneNumber[0].replace(/\s/g, '');
                                    HTMLPhoneString = HTMLPhoneString.replace(phoneNumber, `<a href="tel:${phoneNumberNoSpaces}">${phoneNumber[0]}</a>`);
                                })
                                aPhone.innerHTML = HTMLPhoneString;
                            }  else {
                                aPhone = document.createElement('a');
                                let aPhoneContent = document.createTextNode(address.phone);
                                let aPhoneNoSpaces = address.phone.replace(/\s/g, '');
                                aPhone.href = `tel:${aPhoneNoSpaces}`;
                                aPhone.appendChild(aPhoneContent);
                            }
                            aPhone.classList.add('block');

                            let aGMapsLink
                            if (address.mapLink) {
                                aGMapsLink = document.createElement('a');

                                let aGMapsSpan = document.createElement('span');
                                let aGMapsSpanContent = document.createTextNode("Google Maps");
                                aGMapsSpan.appendChild(aGMapsSpanContent);
                                aGMapsLink.href = address.mapLink;
                                aGMapsLink.setAttribute('target', '_blank');
                                let gMapsSVG = new DOMParser().parseFromString(`<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32.822 32.822"><g fill="#121212" transform="translate(0 .822)"><path d="M24 22v5a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h5a2 2 0 0 0 2-2 2 2 0 0 0-2-2H3a3 3 0 0 0-3 3v22a3 3 0 0 0 3 3h22a3 3 0 0 0 3-3v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2Z"/><rect width="16" height="4" rx="2" transform="translate(16)"/><rect width="16" height="4" rx="2" transform="rotate(90 16 16)"/><rect width="32.296" height="3.971" rx="1.986" transform="rotate(-45 30.162 2.342)"/></g></svg>`, 'application/xml');
                                aGMapsLink.appendChild(aGMapsSpan);
                                aGMapsLink.appendChild(aGMapsSpan.ownerDocument.importNode(gMapsSVG.documentElement, true));
                                aGMapsLink.classList.add('gmapslink');
                            } else {
                                aGMapsLink = document.createElement('span');
                            }

                            let liAddress = document.createElement("li");
                            liAddress.appendChild(h4City);
                            liAddress.appendChild(addressAddress);
                            liAddress.appendChild(aPhone);
                            liAddress.appendChild(aGMapsLink);

                            addressesUl.appendChild(liAddress);
                        }
                    });

                    item.appendChild(addressesUl);
                }
            });
        }).then(() => {
            let queryString = window.location.search;
            let urlParams = new URLSearchParams(queryString);
            let urlOp = urlParams.get('op');
            if (urlOp !== undefined && urlOp == 'encuentranos') {
                modal.showModal();
            }
        });
    }
});